// import Icon from "@material-ui/core/Icon"
import React, { useEffect, useRef, useState } from "react"
import useIsDesktopWidth from "../hooks/useIsDesktopWidth"
import Button from "./generic/buttons/Button"

interface Props {
  maxHeight: number
  amountInfo?: number //indicator of content - shown as a number
}

export const ResizeOverlay: React.FunctionComponent<Props> = ({
  children,
  maxHeight,
  amountInfo
}) => {
  const [height, setHeight] = useState(null)
  const [dragging, setDragging] = useState(false)
  const [mouseStart, setMouseStart] = useState(0)
  const topBar = useRef<HTMLDivElement>(null)
  const overlay = useRef<HTMLDivElement>(null)
  const minHeight = topBar.current ? topBar.current.offsetHeight + 12 : 60
  const isDesktopWidth = useIsDesktopWidth()

  useEffect(() => {
    if (!dragging) {
      return
    }

    function handleResize(e) {
      const h = height ? height : overlay.current.offsetHeight
      if (dragging && h <= maxHeight && h >= minHeight) {
        const pixelDifference = mouseStart - e.movementY
        const newHeight = h + pixelDifference
        setHeight(
          newHeight <= maxHeight && newHeight >= minHeight
            ? newHeight
            : newHeight >= maxHeight
            ? maxHeight
            : minHeight
        )
      }
    }

    function handleMouseUp(e) {
      e.stopPropagation()
      e.preventDefault()
      setDragging(false)
    }

    window.addEventListener("mousemove", handleResize)
    window.addEventListener("mouseup", handleMouseUp)

    return () => {
      window.removeEventListener("mousemove", handleResize)
      window.removeEventListener("mouseup", handleMouseUp)
    }
  }, [dragging, height, mouseStart, maxHeight, minHeight])

  return (
    <div className="ocs-resize-overlay-wrapper">
      <div
        className="ocs-resize-overlay-container d-flex flex-column"
        style={
          isDesktopWidth
            ? {
                height: height ? height + "px" : "auto",
                maxHeight: maxHeight
              }
            : null
        }
        ref={overlay}
      >
        <section
          className={
            "ocs-resize-overlay-top d-flex justify-content-between align-items-center " +
            (dragging ? "cursor-grabbing" : "cursor-grab")
          }
          ref={topBar}
          onMouseDown={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setDragging(true)
            setMouseStart(e.movementY)
          }}
        >
          <div className="d-flex align-items-center">
            <h2 className="ocs-heading-sm-grey">Change Screen</h2>
            {amountInfo ? (
              <div className="ocs-amount-info">{amountInfo}</div>
            ) : null}
          </div>
          <div className="d-flex">
            <Button
              onClick={() => {
                setHeight(minHeight)
              }}
              className="ocs-btn-overlay-icon"
              icon="minimize"
            />
            <Button
              onClick={() => {
                setHeight(maxHeight)
              }}
              className="ocs-btn-overlay-icon"
              icon="north"
            />
            {/* <button
              className={
                "ocs-btn  ocs-btn-only-icon ocs-btn-overlay-icon " +
                (dragging ? "cursor-grabbing" : "cursor-grab")
              }
              onMouseDown={(e) => {
                setDragging(true)
                setMouseStart(e.movementY)
              }}
            >
              <Icon className="ocs-md-btn-icon">import_export</Icon>
            </button> */}
          </div>
        </section>
        {children}
      </div>
    </div>
  )
}

